import { dark, light, PancakeTheme } from '@farmersonly/uikit'
import React, { useState } from 'react'
import { ThemeProvider as SCThemeProvider } from 'styled-components'

const CACHE_KEY = 'IS_DARK'

const ThemeContext = React.createContext({ isDark: null, toggleTheme: () => null })

const ThemeContextProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const isDarkUserSetting = localStorage.getItem(CACHE_KEY)
    return isDarkUserSetting ? JSON.parse(isDarkUserSetting) : false
  })

  const toggleTheme = () => {
    setIsDark((prevState) => {
      localStorage.setItem(CACHE_KEY, JSON.stringify(!prevState))
      return !prevState
    })
  }

  const presaleTheme: PancakeTheme = light
  presaleTheme.modal.background = '#5ab9a7;'
  presaleTheme.colors.primary = '#ffffff'
  presaleTheme.colors.background = '#ecebdd'
  presaleTheme.colors.input = '#515b5b'
  presaleTheme.button.primary.background = '#ffffff'
  presaleTheme.button.primary.backgroundHover = '#f9b69c'
  presaleTheme.button.primary.color = '#e17a5ac9'
  presaleTheme.button.primary.boxShadow = '5px 5px #48716c'
  presaleTheme.button.secondary.background = '#ffffff'
  presaleTheme.button.secondary.backgroundHover = '#022622'
  presaleTheme.button.secondary.border = '#ffffff'
  presaleTheme.button.secondary.color = '#e17a5ac9'
  presaleTheme.button.secondary.boxShadow = '5px 5px #48716c'

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      <SCThemeProvider theme={isDark ? dark : light}>{children}</SCThemeProvider>
    </ThemeContext.Provider>
  )
}

export { ThemeContext, ThemeContextProvider }
